import { render } from "./EnglishXiaozao.vue?vue&type=template&id=7eabab87&scoped=true"
import script from "./EnglishXiaozao.vue?vue&type=script&lang=js"
export * from "./EnglishXiaozao.vue?vue&type=script&lang=js"

import "./EnglishXiaozao.vue?vue&type=style&index=0&id=7eabab87&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eabab87"]])

export default __exports__